import { Component } from "@angular/core";
@Component({
  selector: "gh-example-collapse-component",
  templateUrl: "./example-collapse.component.html",
  styleUrls: ["./example-collapse.component.less"],
})
export class ExampleCollapseComponent {
  public panels = [
    {
      active: true,
      name: "This is panel header 1",
      disabled: false,
      childPanel: [
        {
          active: true,
          name: "This is panel header 1-1",
        },
        {
          active: false,
          name: "This is panel header 1-2",
        },
      ],
    },
    {
      active: false,
      disabled: false,
      name: "This is panel header 2",
    },
    {
      active: false,
      disabled: true,
      name: "This is panel header 3",
    },
  ];

  public customizedPanels = [
    {
      active: true,
      disabled: false,
      name: "This is panel header 1",
      customStyle: {
        background: "#f7f7f7",
        "border-radius": "4px",
        "margin-bottom": "24px",
        border: "0px",
      },
    },
    {
      active: false,
      disabled: true,
      name: "This is panel header 2",
      icon: "double-right",
      customStyle: {
        background: "#f7f7f7",
        "border-radius": "4px",
        "margin-bottom": "24px",
        border: "0px",
      },
    },
    {
      active: false,
      disabled: false,
      name: "This is panel header 3",
      customStyle: {
        background: "#f7f7f7",
        "border-radius": "4px",
        "margin-bottom": "24px",
        border: "0px",
      },
    },
  ];
}
